import React from 'react'
import { EntityInterface } from 'common/types/entities/EntityInterface'
import { useUpdateEntityAppearance } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateEntityAppearance'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'

interface DeviceAppearanceNewProps<T extends EntityInterface> {
  entity: T
}

function DeviceAppearanceNew<T extends EntityInterface>({
  entity,
}: DeviceAppearanceNewProps<T>) {
  const updateAppearance = useUpdateEntityAppearance(entity)
  const toggleDesktop = () =>
    updateAppearance({
      desktop: !entity.appearance.desktop,
      mobile: entity.appearance.desktop ? true : entity.appearance.mobile,
    })

  const toggleMobile = () =>
    updateAppearance({
      desktop: entity.appearance.mobile ? true : entity.appearance.desktop,
      mobile: !entity.appearance.mobile,
    })

  return (
    <>
      <GroupTitle>settings_options.device_appearance.label</GroupTitle>
      <CheckboxNew
        wrapperClassName="mt-4"
        label="settings_options.device_appearance.desktop"
        onChange={toggleDesktop}
        checked={entity.appearance.desktop}
      />
      <CheckboxNew
        wrapperClassName="mt-3"
        label="settings_options.device_appearance.mobile"
        onChange={toggleMobile}
        checked={entity.appearance.mobile}
      />
    </>
  )
}

export default DeviceAppearanceNew
